import React from "react";

const FeatureDescription: React.FC = () => {
  return (
    <div className="named-area">
      <div className="named-area__header">
        <div className="named-area__titles">
          <div className="named-area__title">Enhance Web Accessibility</div>
        </div>
        <div className="named-area__description">
          Transform your website into an inclusive space for all users
        </div>
      </div>
      <div className="named-area__body">
        <div className="a-card a-card--normal">
          <div className="a-card__paddings">
            <div className="promo-row">
              <div className="promo-row__content">
                <ul className="titled-items-list titled-items-list--ordered">
                  <li className="titled-items-list__item titled-item">
                    <div className="titled-item__title">
                      Personalized Reading Experience
                    </div>
                    <div className="titled-item__content">
                      Customize text scaling, line spacing, and font styles to
                      create a comfortable reading environment tailored to
                      individual needs.
                    </div>
                  </li>
                  <li className="titled-items-list__item titled-item">
                    <div className="titled-item__title">
                      Seamless Navigation
                    </div>
                    <div className="titled-item__content">
                      Enable effortless browsing with link identification,
                      flicker-free modes, and enhanced mouse navigation using
                      large cursors.
                    </div>
                  </li>
                  <li className="titled-items-list__item titled-item">
                    <div className="titled-item__title">
                      Multilingual Text-to-Speech
                    </div>
                    <div className="titled-item__content">
                      Support users with visual impairments through
                      Text-to-Speech functionality in over 60 languages,
                      ensuring content accessibility for everyone.
                    </div>
                  </li>
                </ul>
              </div>
              <div className="promo-row__image">
                <img
                  src="/demo.png"
                  alt="Accessibility features illustration"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureDescription;
